var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"loader-wrapper",class:{'loderhide' : !_vm.show }},[_vm._m(0)]),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('img',{attrs:{"src":require("./assets/images/logo/blast.jpg"),"alt":""}}),_c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"loader-17"})])])
}]

export { render, staticRenderFns }